// Consent + analytics manager for MDD.
// - Stores user consent in localStorage as { essential: true, analytics: bool, advertising: bool, ts: ISO }
// - Loads Meta Pixel only when advertising consent is granted
// - Loads Google Analytics 4 only when analytics consent is granted
// - Provides safe wrappers to track standard events from anywhere in the app

const META_PIXEL_ID = '790220032788538';
const GA4_ID = 'G-CC6BSPC5FL';
const STORAGE_KEY = 'mdd_consent_v1';

let metaLoaded = false;
let ga4Loaded = false;

export function getConsent() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    return JSON.parse(raw);
  } catch {
    return null;
  }
}

export function saveConsent(consent) {
  const payload = {
    essential: true,
    analytics: !!consent.analytics,
    advertising: !!consent.advertising,
    ts: new Date().toISOString(),
  };
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(payload));
  } catch {
    /* ignore */
  }
  applyConsent(payload);
  return payload;
}

export function clearConsent() {
  try {
    localStorage.removeItem(STORAGE_KEY);
  } catch {
    /* ignore */
  }
}

function loadMetaPixel() {
  if (metaLoaded || typeof window === 'undefined') return;
  metaLoaded = true;
  // Meta Pixel base code
  /* eslint-disable */
  !(function (f, b, e, v, n, t, s) {
    if (f.fbq) return;
    n = f.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
    };
    if (!f._fbq) f._fbq = n;
    n.push = n;
    n.loaded = !0;
    n.version = '2.0';
    n.queue = [];
    t = b.createElement(e);
    t.async = !0;
    t.src = v;
    s = b.getElementsByTagName(e)[0];
    s.parentNode.insertBefore(t, s);
  })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
  /* eslint-enable */
  window.fbq('init', META_PIXEL_ID);
  window.fbq('track', 'PageView');
}

function loadGA4() {
  if (ga4Loaded || typeof window === 'undefined') return;
  ga4Loaded = true;
  const s = document.createElement('script');
  s.async = true;
  s.src = `https://www.googletagmanager.com/gtag/js?id=${GA4_ID}`;
  document.head.appendChild(s);
  window.dataLayer = window.dataLayer || [];
  window.gtag = function gtag() {
    window.dataLayer.push(arguments);
  };
  window.gtag('js', new Date());
  window.gtag('config', GA4_ID, { send_page_view: true });
}

export function applyConsent(consent) {
  if (!consent) return;
  if (consent.advertising) loadMetaPixel();
  if (consent.analytics) loadGA4();
}

// Public helpers — all are safe even when consent has not been granted
export function trackEvent(name, params = {}) {
  if (typeof window === 'undefined') return;
  const c = getConsent();
  if (c?.advertising && window.fbq) {
    try { window.fbq('track', name, params); } catch { /* ignore */ }
  }
  if (c?.analytics && window.gtag) {
    try { window.gtag('event', name, params); } catch { /* ignore */ }
  }
}

export function trackPageView(path) {
  if (typeof window === 'undefined') return;
  const c = getConsent();
  if (c?.advertising && window.fbq) {
    try { window.fbq('track', 'PageView'); } catch { /* ignore */ }
  }
  if (c?.analytics && window.gtag) {
    try {
      window.gtag('event', 'page_view', { page_path: path || window.location.pathname });
    } catch { /* ignore */ }
  }
}

// Apply consent immediately on module load if user already chose
if (typeof window !== 'undefined') {
  const existing = getConsent();
  if (existing) applyConsent(existing);
}
